var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showModalBox)?_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"modal-box-c"},[_c('h4',[_vm._v("修改成功")]),_c('span',[_vm._v("请重新登陆！"+_vm._s(_vm.num)+"s后将自动返回首页页面")]),_c('div',{staticClass:"comfirm"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.comfirm}},[_vm._v("重新登陆")])],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }